import type { ReactNode } from "react";
import { CustomTypography } from "sipli-fleet-core/components";

interface UnitManagementPanelProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  children: ReactNode;
}

const UnitManagementPanel = ({
  icon,
  title,
  description,
  children,
}: UnitManagementPanelProps) => (
  <div className="device-install-panel">
    <div className="device-install-panel-header">
      <div className="flex items-center gap-4">
        {icon}
        <CustomTypography.CustomText className="!text-[17.72px] !font-bold !text-black">
          {title}
        </CustomTypography.CustomText>
      </div>
      <CustomTypography.CustomText className="!text-sm !text-gray9">
        {description}
      </CustomTypography.CustomText>
    </div>
    <div className="device-install-divider" />
    {children}
  </div>
);

export default UnitManagementPanel;
